import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import GradeViewModel from '../ViewModels/GradeViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IGradeProps {
    setGrade: (value, askLevel2) => void;
    grade: string | undefined;
    disabled: boolean;
    label: string;
    gradeType: string
}

interface IGradeState {
    model: GradeViewModel[];
    loaded: boolean;
}

class Grade extends Component<IGradeProps & WithStyles<typeof styles>, IGradeState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetGrades').then(response => response.json()).then((data) => {
            console.log(data);
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultGradeVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.label}
                name={this.props.gradeType === "Eng" ? "gcseEnglishGrade" : this.props.gradeType === "EngLit" ? "gcseEnglishLitGrade" : "gcseMathsGrade"}
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.grade}
                onChange={this.props.disabled ? undefined : this.setGrade}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }

    public setGrade = (event) => {
        let selectedValue = this.state.model.filter(x => x.value === event.target.value)[0];
        this.props.setGrade(selectedValue.value, selectedValue.askYear11);
    }
}

export default withStyles(styles)(Grade);